<template>
  <div class="wrap-page-loading">
    <b-container>
      <div class="box-carousel">
        <Skeleton
          width="100%"
          height="50vh"
        />
      </div>
      <b-row class="box-nav">
        <b-col
          v-for="i in 3"
          :key="i"
        >
          <Skeleton
            width="100%"
            height="76px"
          />
        </b-col>
      </b-row>
      <div class="box-content">
        <Skeleton
          v-for="i in 3"
          :key="i"
          width="100%"
          height="20px"
        />
      </div>
    </b-container>
  </div>
</template>

<script>
const Skeleton = () => import('@/components/Loading/Skeleton')

export default {
  components: {
    Skeleton
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-page-loading {
  background-color: white;
  position: relative;
  z-index: 30;

  @media only screen and (min-width: $break-m) {
    padding-top: 55px;
    z-index: 0;
    background: none;
  }

  .box-carousel, .box-nav, .box-content {
    padding: 14px 0;
  }

  .box-content {
    div {
      margin-top: 10px;
    }
  }
}
</style>
